// Create an array of number based from `start` and `end`
// range(1, 5) - will generate an array that will produce [1,2,3,4,5]
export const range = (start, end) => [...Array(end - start + 1)].map((_, i) => start + i);
